const steps: Array<string> = [
  'Выберите<br>профиль',
  'Создайте<br>запрос',
  'Получите<br>наставника',
  'Вместе<br>вы&nbsp;команда',
  'Развивайтесь<br>и&nbsp;совершенствуйтесь',
];

export default steps;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/process/consts.ts